import { useEffect, useState } from 'react';
import { useAuthenticatedFetch } from '../../hooks/useAuthenticatedFetch';
import type { PlanFeature } from '../../contexts/PlanContext';

export interface CatalogPlan {
  id: string; name: string; displayName: string; description: string | null;
  monthlyPrice: number; maxUsers: number; maxContacts: number; maxCampaigns: number; maxConnections: number;
  features: PlanFeature[]; aiDailyRequests: number | null; purchasable: boolean;
}

let cache: { at: number; plans: CatalogPlan[] } | null = null;

/** Planos à venda (cache de 5 min): para dizer em qual plano um recurso está */
export function usePlanCatalog() {
  const fetchApi = useAuthenticatedFetch();
  const [plans, setPlans] = useState<CatalogPlan[] | null>(cache && Date.now() - cache.at < 300_000 ? cache.plans : null);
  useEffect(() => {
    if (plans) return;
    let alive = true;
    fetchApi('/api/billing/planos')
      .then((r) => (r.ok ? r.json() : { plans: [] }))
      .then((b: { plans?: CatalogPlan[] }) => { cache = { at: Date.now(), plans: b.plans ?? [] }; if (alive) setPlans(cache.plans); })
      .catch(() => alive && setPlans([]));
    return () => { alive = false; };
  }, [fetchApi, plans]);
  return plans;
}

/** Plano mais barato à venda que inclui o recurso */
export const cheapestWith = (plans: CatalogPlan[] | null, f: PlanFeature) =>
  (plans ?? []).filter((p) => p.features.includes(f)).sort((a, b) => a.monthlyPrice - b.monthlyPrice)[0] ?? null;
